<template>
  <vs-row>
    <vs-col
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-md="12"
      vs-sm="12"
    >
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <h1 class="">Pago</h1>
        </vs-col>
      </vs-row>
      <vs-divider color="#197CBF"></vs-divider>
      <vs-row vs-justify="center">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <h2>Total a Pagar</h2>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <h2>{{ moneyFormat(totalPrice) }}</h2>
        </div>
      </vs-row>
      <vs-divider color="#197CBF"></vs-divider>
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="left">
          <h5 class="">Banco</h5>
        </vs-col>
      </vs-row>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Banco *</label>
          <v-select
            v-model="bank"
            :options="banks"
            label="nombre"
            :clearable="false"
            :searchable="true"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.bank.$error">{{
            requiredErrorMessage
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label class="vs-input--label">Tipo de tarjeta *</label>
          <v-select
            v-model="cardType"
            :options="cardTypeOptions"
            :reduce="(cardTypeOption) => cardTypeOption.title"
            label="title"
            :clearable="false"
            :searchable="false"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.cardType.$error">{{
            requiredErrorMessage
          }}</span>
        </div>
      </div>
      <vs-divider color="#197CBF"></vs-divider>
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="left">
          <h5 class="">Pago</h5>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          v-if="false && showOptionsToPay"
        >
          <vs-radio v-model="paymentSplitsType" vs-value="cash" class="pr-10">
            Pago Contado
          </vs-radio>
          <vs-radio v-model="paymentSplitsType" vs-value="splits">
            Pago en Cuotas
          </vs-radio>
        </vs-col>
      </vs-row>
      <vs-alert
        icon="new_releases"
        color="warning"
        class="mb-4"
        title="Uso de tarjeta"
        :active.sync="showCreditCardTerms"
      >
        <span class="text-sm">
          Esta tarjeta quedará registrada y se realizarán cobros automáticos
          recurrentes de tus cuotas o servicios
        </span>
      </vs-alert>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-xl="12"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
      </vs-col>
      <!-- </vs-row> -->

      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xl="3"
          vs-lg="3"
          vs-sm="12"
          vs-xs="12"
        >
          <!-- vs-sm="4" vs-xs="12" -->
        </vs-col>

        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-xl="6"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          <credit-card-widget
            v-if="creditCard && paymentSplitsType == 'cash'"
            :locationApiKey="locationApiKey"
            :locationMid="locationMid"
            :locationTid="locationTid"
            @SaveCreditCardSuccess="SaveCreditCardSuccess"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xl="3"
          vs-lg="3"
          vs-sm="12"
          vs-xs="12"
        >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" v-if="$v.card.$error">
          <span class="text-danger text-sm">{{ requiredCreditCard }}</span>
        </vs-col>
        <vs-col>
          <vs-alert
            icon="new_releases"
            color="primary"
            class="mt-4"
            title="Uso de tarjeta"
            :active.sync="showAnnualTermsPayingWithCard"
          >
            <span class="text-sm">
              <vs-checkbox color="#197CBF" v-model="acceptAnnualTerms">
                <div>
                  Al aceptar, se te cobrará la totalidad de la membresía
                </div>
              </vs-checkbox>
            </span>
          </vs-alert>
        </vs-col>
      </vs-row>

      <vs-divider color="#197CBF"></vs-divider>
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="left">
          <h5 class="">Facturacion</h5>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center">
          <ul class="centerx invoice">
            <li class="pl-10">
              <vs-radio color="#197CBF" v-model="invoiceType" vs-value=""
                >Facturar a NIT</vs-radio
              >
            </li>
            <li class="pl-10">
              <vs-radio color="#197CBF" v-model="invoiceType" vs-value="cf"
                >Consumidor Final</vs-radio
              >
            </li>
          </ul>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Nit *"
            color="#197CBF"
            name="tinNumber"
            v-model="tinNumber"
            class="w-full"
            :disabled="invoiceCF"
          />
          <span class="text-danger text-sm" v-if="$v.tinNumber.$error">{{
            requiredErrorMessage
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-input
            label="Nombre *"
            color="#197CBF"
            name="name"
            v-model="name"
            class="w-full"
            :disabled="invoiceCF"
          />
          <span class="text-danger text-sm" v-if="$v.name.$error">{{
            requiredErrorMessage
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!invoiceCF">
          <vs-input
            label="Direccion *"
            color="#197CBF"
            name="address"
            v-model="address"
            class="w-full"
          />
          <span class="text-danger text-sm" v-if="$v.address.$error">{{
            requiredErrorMessage
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!invoiceCF">
          <vs-input
            label="Codigo Postal *"
            color="#197CBF"
            name="zipCode"
            v-model="zipCode"
            class="w-full"
          />
          <span class="text-danger text-sm" v-if="$v.zipCode.$error">{{
            requiredErrorMessage
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!invoiceCF">
          <label class="vs-input--label">Departamento *</label>
          <v-select
            v-model="state"
            :options="stateOptions"
            :reduce="(stateOption) => stateOption.title"
            label="title"
            :clearable="false"
            :searchable="true"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>
          <span class="text-danger text-sm" v-if="$v.state.$error">{{
            requiredErrorMessage
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!invoiceCF">
          <label class="vs-input--label">Municipio *</label>
          <v-select
            v-model="city"
            :options="cityOptions"
            :clearable="false"
            :searchable="true"
          >
            <template #no-options> Lo sentimos, no hay opciones </template>
          </v-select>

          <span class="text-danger text-sm" v-if="$v.city.$error">{{
            requiredErrorMessage
          }}</span>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
//import $ from "jquery";
import { required } from "vuelidate/lib/validators";
import banksConstant from "@/constants/banks.constant";
import cardTypeConstant from "@/constants/cardType.constant";
import messageError from "@/constants/messageError.constants";
import CreditCardWidget from "@/views/forms/form-wizard/credit-card/CreditCardWidget.vue";
import utils from "@/views/forms/form-wizard/form-wizard-register/utils";
export default {
  name: "third-step",
  components: { CreditCardWidget },
  props: [
    "totalPrice",
    "stateOptions",
    "locationApiKey",
    "locationTid",
    "locationMid",
    "creditCard",
    "banks",
    "packagePeriodicity",
  ],
  emits: ["on-validated", "on-save-card"],
  data() {
    return {
      cityOptions: [],
      bankOptions: banksConstant,
      cardTypeOptions: cardTypeConstant,

      bank: "",
      cardType: "",

      invoiceCF: false,
      invoiceType: "",

      tinNumber: "",
      name: "",
      address: "",
      zipCode: "",
      city: "",
      state: "",

      card: {
        TokenDetails: {
          AccountToken: "",
          AccountNumber: "",
          CardHolderName: "",
          CardNumber: "",
          card_type: "",
          exp_month: 0,
          exp_year: 0,
          c_number: 0,
        },
      },
      acceptAnnualTerms: false,

      model: {
        finish: false,
        card_details: {
          cardToken: "",
          accountNumber: "",
          cardholderName: "",
          associatedCard: "",
          bank: "",
          type: "",
          card_type: "",
          bank_entity: "",
          exp_month: 0,
          exp_year: 0,
          c_number: 0,
        },
        invoice_details: {
          nit: "",
          nombre_sat: "",
          direccion_fact: "",
          cod_fact: "",
          departamento_fact: "",
          municipio_fact: "",
        },
      },

      requiredErrorMessage: messageError.REQUIRED_ERROR_MESSAGE,
      requiredCreditCard: messageError.REQUIRED_CREDIT_CARD,

      showCreditCardTerms: false,
      showAnnualTermsPayingWithCard: false,

      paymentSplitsType: "cash",
      paymentIsSplits: false,

      showOptionsToPay: false,
    };
  },
  methods: {
    moneyFormat(amount) {
      const amountNumber = Number(amount);
      const formattedAmount = amountNumber.toLocaleString("es-GT", {
        style: "currency",
        currency: "GTQ",
      });
      return formattedAmount;
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.model.finish = true;
        // FEL DATA
        this.model.invoice_details.nit = this.tinNumber;
        this.model.invoice_details.nombre_sat = this.name;
        this.model.invoice_details.direccion_fact = this.address;
        this.model.invoice_details.cod_fact = this.zipCode;
        this.model.invoice_details.departamento_fact = this.state;
        this.model.invoice_details.municipio_fact = this.city;
        // CARD DATA
        this.model.card_details.cardToken =
          this.card.TokenDetails.AccountToken || "";
        this.model.card_details.accountNumber =
          this.card.TokenDetails.AccountNumber;
        this.model.card_details.cardholderName =
          this.card.TokenDetails.CardHolderName;
        this.model.card_details.associatedCard =
          this.card.TokenDetails.CardNumber;
        this.model.card_details.bank = this.bank.nombre;
        this.model.card_details.type = this.cardType;

        this.model.card_details.card_type = this.card.TokenDetails.card_type;
        this.model.card_details.bank_entity = this.bank.codigo;
        this.model.card_details.exp_month = this.card.TokenDetails.exp_month;
        this.model.card_details.exp_year = this.card.TokenDetails.exp_year;
        this.model.card_details.c_number = this.card.TokenDetails.c_number;

        this.$emit("on-validated", this.model);
        return true;
      } else {
        this.$vs.loading.close();
        utils.nextStep();
        return false;
      }
    },
    SaveCreditCardSuccess(response) {
      this.card = response;
      this.$emit("on-save-card", this.card);
    },
  },
  validations() {
    const validations = {
      card: { required },
      bank: { required },
      cardType: { required },
      tinNumber: { required },
      name: { required },
    };

    if (!this.invoiceCF) {
      validations.address = { required };
      validations.zipCode = { required };
      validations.state = { required };
      validations.city = { required };
    }

    if (this.packagePeriodicity == 4) {
      validations.acceptAnnualTerms = { required };
    }

    if (this.paymentSplitsType == "splits") {
      validations.card = {};
      validations.bank = {};
      validations.cardType = {};
      validations.tinNumber = {};
      validations.name = {};
    }

    return validations;
  },
  watch: {
    invoiceType() {
      if (this.invoiceType == "cf") {
        this.invoiceCF = true;
        this.name = "CF";
        this.tinNumber = "CF";
        this.zipCode = "01010";
        this.address = "Ciudad";
        this.state = "Guatemala";
        this.city = "Guatemala";
      } else {
        this.invoiceCF = false;
        this.name = "";
        this.tinNumber = "";
        this.zipCode = "";
        this.address = "";
        this.state = "";
        this.city = "";
      }
    },
    state() {
      if (this.state) {
        this.city = this.invoiceType == "cf" ? "Guatemala" : "";
        this.cityOptions = this.stateOptions.find(
          (state) => state.title == this.state
        ).cities;
      }
    },
    creditCard() {
      this.card = {};
    },
    totalPrice: {
      handler(val) {
        if (val == 0) {
          this.showCreditCardTerms = false;
          return;
        }
        if (this.packagePeriodicity == 4) {
          this.showCreditCardTerms = false;
          return;
        }
        this.showCreditCardTerms = true;
      },
      immediate: true,
    },
    packagePeriodicity: {
      handler(val) {
        //periodicity = 1 mensual, periodicity = 4 anual
        if (val == 4) {
          this.showOptionsToPay = true;
          return;
        }

        if (val == 1) {
          this.paymentSplitsType = "cash";
          this.showOptionsToPay = false;
          return;
        }

        this.showAnnualTermsPayingWithCard = false;
      },
      immediate: true,
    },
    paymentSplitsType: {
      handler(val) {
        if (val == "cash") {
          this.showCreditCardTerms = true;
          if (this.packagePeriodicity == 4) {
            this.showAnnualTermsPayingWithCard = true;
          }
          this.paymentIsSplits = false;
        } else if (val == "splits") {
          this.paymentIsSplits = true;
          this.showCreditCardTerms = false;
          this.showAnnualTermsPayingWithCard = false;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.invoice {
  display: flex;
  justify-content: space-between;
}
</style>
